<template>
  <div class="container">
    <video ref="video" loop>
      <source :src="src" type="video/mp4" />
    </video>
    <div @click="toggle" class="control">
      <div
        v-if="showCover"
        class="cover"
        :style="{ backgroundImage: 'url(' + cover + ')' }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    cover: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isPlaying: false,
    }
  },
  computed: {
    showCover() {
      return this.cover !== null && !this.isPlaying
    },
  },
  methods: {
    toggle() {
      const video = this.$refs.video
      if (video.paused) {
        video.play()
        this.isPlaying = true
      } else {
        video.pause()
        this.isPlaying = false
      }
    },
  },
  beforeDestroy() {
    try {
      this.$refs.video.pause()
    } catch (error) {}
  },
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 100%;
  text-align: center;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.control {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.cover {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoPlayer.vue